<template>
    <div class="home">
        <NavbarComp />
        <HeroComp />
        <keunggulan title1="Kenapa Harus Intelligo?"
            title2="Intelligo memiliki beberapa keunggulan yang membantu para siswa dalam belajar"
            why1="Mentoring 1 on 1" desc1="Berinteraksi bareng mentor secara langsung" why2="Study Case"
            desc2="Siswa akan diberikan study case untuk berlatih" why3="Portofolio"
            desc3="Membangun portofolio yang bagus untuk dunia kerja" why4="Join Komunitas"
            desc4="Tergabung komunitas internal untuk sharing session" why5="Side Project"
            desc5="Berpeluang untuk terlibat dalam project" why6="Harga Terjangkau"
            desc6="Harga yang kami tawarkan sangat terjangkau" />
        <OurProgram />
        <ProceduresForUse judul3="Lakukan Pembayaran"
            isi3="Sobat inteligo bisa melakukan pendaftara akun terlebih dahulu dan apabila sudah memiliki akun maka bisa langsung login ke halaman utama"
            ebanking="E-Banking" transfer="Transfer" hargadatascience="IDR 999.000" datascience="Data Science Bootcamp"
            hargawebdev="IDR 999.000" webdev="Web Development" judul4="Siap untuk Belajar!!"
            isi4="Sobat inteligo bisa melakukan pendaftara akun terlebih dahulu dan apabila sudah memiliki akun maka bisa langsung login ke halaman utama" />
        <TestiComp />
        <JoinOur />
        <FooterComp />
    </div>
</template>

<script>
    import NavbarComp from "../components/NavbarComp.vue";
    import HeroComp from "../components/HeroComp.vue";
    import keunggulan from "../components/keunggulan.vue";
    import OurProgram from "../components/OurProgram.vue";
    import ProceduresForUse from "../components/ProceduresForUse.vue";
    import TestiComp from "../components/TestiComp.vue";
    import JoinOur from "../components/JoinOur.vue";
    import FooterComp from "../components/FooterComp.vue";
    export default {
        name: `HomeView`,
        components: {
            NavbarComp,
            HeroComp,
            keunggulan,
            OurProgram,
            ProceduresForUse,
            TestiComp,
            JoinOur,
            FooterComp,
        },
    }
</script>

<style>
</style>